import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import clsx from "clsx";
import type { IAuditoriaEventoGrupo } from "@/api/space/dtos/authenticator.dto";
import { AUDITORIA_TIPO_LABELS } from "../auditoria.constants";
import { formatarHoraAuditoria } from "../auditoria.utils";

const ICONE_TIPO: Record<IAuditoriaEventoGrupo["tipo"], string> = {
	salvar_acessos_grupo_usuario: "lucide:shield-check",
	clonar_grupo_usuario: "lucide:copy",
};

/** Cabeçalho comum dos cards de evento: ícone (por tipo) + autor + tipo + hora. */
export default function CabecalhoEvento({ evento }: { readonly evento: IAuditoriaEventoGrupo }) {
	const ehSalvar = evento.tipo === "salvar_acessos_grupo_usuario";

	return (
		<>
			<div
				className={clsx(
					"flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
					ehSalvar ? "bg-primary/10 text-primary" : "bg-info/10 text-info",
				)}
			>
				<FuseSvgIcon size={18}>{ICONE_TIPO[evento.tipo]}</FuseSvgIcon>
			</div>

			<div className="min-w-0 flex-1">
				<div className="flex min-w-0 items-center gap-2">
					<span className="truncate text-sm font-bold text-foreground">{evento.autor.nome}</span>
					<span className="shrink-0 text-xs font-medium text-muted-foreground">
						· {AUDITORIA_TIPO_LABELS[evento.tipo]}
					</span>
				</div>
			</div>

			<span className="shrink-0 text-[13px] font-medium text-muted-foreground">
				{formatarHoraAuditoria(evento.data_hora_utc)}
			</span>
		</>
	);
}
